export const required = value =>
	typeof value !== 'undefined' &&
	value !== null &&
	value !== false &&
	value.toString().trim() !== '';

export const minlength = (value, rule) => value.toString().length >= rule;

export const maxlength = (value, rule) => value.toString().length <= rule;

export const minvalue = (value, rule) =>
	!isNaN(value) && parseInt(value, 10) >= rule;

export const maxvalue = (value, rule) =>
	!isNaN(value) && parseInt(value, 10) <= rule;

export const allowedfraction = (value, rule) =>
	value !== null &&
	!isNaN(value) &&
	(rule === 0 || (rule === 1 && value.toString().indexOf('.') < 0));

export const allowedinteger = (value, rule) =>
	value !== null && !isNaN(value) && value.toString().length <= rule;

export const pattern = (value, rule) => {
	const regex = new RegExp(rule);
	return regex.test(value);
};

export const patternList = pattern;
